@import 'styles/mixins';
@import 'styles/variables';

.promptContainer {
  transition: flex-basis 250ms ease-in-out;
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 0;

  &.promptActive {
    flex-basis: 100%;
  }

  @include for-phone-only {
    gap: 8px;
  }
}

.buttonContainer {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 1;
  
  @include for-phone-only {
    flex-direction: column;
  }
}

